import React from 'react';
import { Button } from 'reactstrap';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

function NumberActivated() {
  const { id } = useParams();
  const history = useHistory();
  const activationMsg = useSelector(state => state.UIState.inteliquent.activateNumberStatus);
  return (
    <div className="text-center">
      <div className="my-5">
        <div className="lead">Your Number is Activated</div>
        <p>{activationMsg}</p>
      </div>
      <Button color="primary" onClick={() => history.push('/provisioning/porting')}>
        Move back to porting list
      </Button>
    </div>
  );
}
export default NumberActivated;
